import FeatureNotice from "@/v2-backoffice-client/feature/FeatureNotice"
import { IS_CATALOG_AUTHORING_ENABLED } from "@/v2-backoffice-client/feature/feature.constants"

export type FeatureHotfixNoticeProps = {
  className?: string
}

/**
 * Warns that this deployment has no authoring catalog, so a save is a
 * hotfix: it lands on the live runtime row and the next catalog publish
 * overwrites it. Shown above every catalog editor — layers, basemaps and
 * nav layers all dual-write the same way, so they all lose the same thing
 * when the second write has nowhere to go.
 *
 * Renders nothing where the catalog IS reachable, so call sites can mount
 * it unconditionally.
 */
function FeatureHotfixNotice(props: FeatureHotfixNoticeProps) {
  const { className } = props

  if (IS_CATALOG_AUTHORING_ENABLED) return null

  return (
    <FeatureNotice tone="warning" className={className}>
      Hotfix mode: this deployment has no authoring catalog, so saves land on
      the live runtime only and the next catalog publish overwrites them. Make
      durable edits in the dev backoffice.
    </FeatureNotice>
  )
}

export default FeatureHotfixNotice
